// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import Vuetify from "vuetify";
import axios from "axios";
import VueResource from "vue-resource";
import "vuetify/dist/vuetify.min.css";
import VueSweetalert2 from "vue-sweetalert2";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";
import router from "./router";
import store from "./store";
import {applyGuards} from "./router/guards";
import {normalizeProtocoloQueryShim} from "./boot/normalize-protocolo-query-shim";


Vue.use(Vuetify, {
  iconfont: "mdi",
});
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

normalizeProtocoloQueryShim();
applyGuards(router, store);

axios.defaults.baseURL = process.env.VUE_APP_API_URI;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.request.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      store.dispatch("setRedirectTo", router.currentRoute.path);
      router.push("/");
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

Vue.filter("formatDate", (value) => {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
  return "";
});
Vue.filter("formatDate2", (value) => {
  if (value) {
    return moment(String(value), "YYYY/MM/DD").format("DD/MM/YYYY");
  }
  return "";
});

Vue.filter("formatTimestamp", (value) => {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY [às] HH:mm ");
  }
  return "";
});

Vue.filter("formatDateTime", (value) => {
  if (value) {
    return moment(String(value)).format("HH:mm DD/MM/YYYY");
  }
  return "";
});

Vue.config.productionTip = false;
Vue.config.runtimeCompiler = true;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: {
    default_base_url: "http://localhost:8080/",
  },
  router,
  store,
  components: { App },
  template: "<App/>",
});

